module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionCgcjMobile.8bc1756b.png";